<template>
  <!-- لیست کشویی شرح حساب -->
  <div class="ml-3 divFilterSDocDesc" v-bind:style="setLocationShow()">
    <div class="table-respon" style="max-height: 140px; overflow-y: auto">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead>
          <td class="bg-primary-light">شرح سند ({{ TbDataFilter.length }} مورد)</td>
        </thead>
        <tbody>
          <tr v-for="row in TbDataFilter" :key="row.NCode" v-on:click="selectRow(row.NCode, row.SDesc)"
            v-on:dblclick="dblClickRow(row.NCode, row.SDesc)" v-bind:id="'rowFilter-' + row.NCode"
            :class="{ selRow: selectNCode == row.NCode }" style="cursor: pointer;">
            <td>{{ row.SDesc }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row h12 text-secondary mt-2 d-flex justify-content-center align-items-center">راهنما : فلش <i
        class="fas fa-long-arrow-alt-up px-1"></i> و <i class="fas fa-long-arrow-alt-down px-1"></i> حرکت بین سطرها ،
      F4/Enter انتخاب</div>
  </div>
</template>

<script>
import { BusEvent } from "../../../../../main.js";

export default {
  data() {
    return {
      // مخزن اصلی اطلاعات
      TbData: [],
      // چیزی که دیده می شود
      TbDataFilter: [],
      // اطلاعات سطر در حال انتخاب
      selectNCode: 0,
      selectRowSDesc: "",
    };
  },
  // SDocDesc : شرح سند جاری
  // ListTbAccDocRecord : لیست شرح ردیف های سند جاری
  props: ["FilterSDesc", "SDocDesc", "ListTbAccDocRecord", "LocationShow"],
  watch: {
    FilterSDesc: function (value) {
      this.filterTbData(value);
    },
  },
  methods: {
    setLocationShow() {
      return "left: " + parseInt(this.LocationShow.left + 25) + "px; width: " + parseInt(this.LocationShow.width) + "px; margin-top: " + parseInt(this.LocationShow.top + this.LocationShow.height + 12) + "px;";
    },
    async getTbData() {
      this.TbData = await this.$store.getters.getTbBaseAccDescData;

      // افزودن شرح سند به مخزن اصلی
      if (this.SDocDesc != "") {
        // اگر شرح جدید در مخزن اصلی سابقه نداشت
        let index = this.TbData.findIndex(
          (itme) => itme.SDesc.toString() === this.SDocDesc.toString()
        );
        if (index == -1) {
          // تولید کد منحصر به فرد جهت درج شرح سند به مخزن اصلی
          let ncode = 0;
          this.TbData.forEach(item => {
            if (ncode < item.NCode) {
              ncode = item.NCode;
            }
          });
          ncode++;
          this.TbData.push({
            DTime: '',
            NCode: ncode,
            NUserCode: 1,
            SDate: '',
            SDesc: this.SDocDesc
          });
          ncode++;
        }
      }

      // مقدار دهی مخزن فیلتر
      this.TbDataFilter = this.TbData;
    },

    filterTbData(SDesc) {
      this.TbDataFilter = this.TbData.filter(function (t) {
        return t.SDesc.toString().includes(SDesc);
      });
    },

    dblClickRow(NCode, SDesc) {
      this.selectRow(NCode, SDesc);
      this.SelectHesab();
    },

    selectRow(NCode, SDesc) {
      this.selectNCode = NCode;
      this.selectRowSDesc = SDesc;
    },

    SelectHesab() {
      if (this.selectNCode == 0) {
        this.$store.dispatch(
          "notify",
          "سطری در حالت انتخاب نیست !\nلطفا ابتدا یکی از سطرها را در حالت انتخاب قرار دهید ."
        );
      } else {
        this.$emit("HideFilter", {
          NCode: this.selectNCode,
          SDesc: this.selectRowSDesc,
        });
      }
    },

    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      //alert('filter hesab : ' + keyvalue.key);
      if (this.TbDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbDataFilter.findIndex(
            (itme) => itme.NCode == this.selectNCode
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRow(
                  this.TbDataFilter[index - 1].NCode,
                  this.TbDataFilter[index - 1].SDesc,
                );
                $(
                  "#rowFilter-" + this.TbDataFilter[index - 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            } else {
              if (index + 1 < this.TbDataFilter.length) {
                this.selectRow(
                  this.TbDataFilter[index + 1].NCode,
                  this.TbDataFilter[index + 1].SDesc,
                );
                $(
                  "#rowFilter-" + this.TbDataFilter[index + 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            }
          } else {
            this.selectRow(
              this.TbDataFilter[0].NCode,
              this.TbDataFilter[0].SDesc,
            );
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4" || keyvalue.key === "Enter") {
          this.SelectHesab();
        }
      }
    },
  },
  created() {
    this.getTbData();
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    //alert('Destroy Filter');
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
};
</script>

<style scoped>
.divFilterSDocDesc {
  position: absolute;
  background-color: #fee3e8;
  /* width: 300px; */
  min-height: 80px;
  max-height: 170px;
  /* margin-top: 35px; */
  z-index: 99999;
  /* top: 52px; */
  padding: 5px;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 5px;
}

.divFilterSDocDesc table {
  background-color: white;
}

.selRow {
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/Components/FilterSAccDesc.vue